import { render, staticRenderFns } from "./TipModal.vue?vue&type=template&id=1674b295&scoped=true&"
import script from "./TipModal.vue?vue&type=script&lang=js&"
export * from "./TipModal.vue?vue&type=script&lang=js&"
import style0 from "./TipModal.vue?vue&type=style&index=0&id=1674b295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674b295",
  null
  
)

component.options.__file = "TipModal.vue"
export default component.exports